import { render } from "./VabeneAddNotification.vue?vue&type=template&id=f06aeafa&ts=true"
import script from "./VabeneAddNotification.vue?vue&type=script&lang=ts"
export * from "./VabeneAddNotification.vue?vue&type=script&lang=ts"

import "./VabeneAddNotification.vue?vue&type=style&index=0&id=f06aeafa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__